import React, { useRef, useState } from "react";
import Box from "@mui/material/Box";
import Draggable from "react-draggable";
import MagnifyingGlass from "./../../assets/images/board/lupa.svg";
import MoveIcon from "@mui/icons-material/TouchApp";
import Button from "@mui/material/Button";
import DefaultHint from "../../assets/images/generic/AreaLupa.jpg";
import "./styles.scss";
import { motion } from "framer-motion";

type Props = {
  hint: string;
  search: string;
  onUseMagnifyingGlass: () => void;
};

export default function MgGlass(props: Props) {
  const hintRef = useRef<HTMLImageElement>(null);
  const [showGlass, setShowGlass] = useState(false);
  const [mgUsed, setMgUsed] = useState(false);

  const searchClue = () => {
    if (showGlass) {
      setShowGlass(false);
    } else {
      if (!mgUsed) {
        props.onUseMagnifyingGlass();
        setMgUsed(true);
      }

      setShowGlass(true);
    }
  };

  const hideSearchClue = () => {
    setShowGlass(false);
  };

  return (
    <Box>
      <div className="mg-container">
        {showGlass && (
          <Draggable defaultPosition={{ x: 0, y: 0 }}>
            <div className="magnifying-glass-circle">
              <img
                style={{ zIndex: 100 }}
                onDoubleClick={hideSearchClue}
                ref={hintRef}
                src={MagnifyingGlass}
              />
              <MoveIcon style={{ width: 40, height: 40, color: "black" }} />
            </div>
          </Draggable>
        )}
        <div className="mg-hint">
          <img src={mgUsed ? props.hint : DefaultHint} />
        </div>
        <div className="mg-icon">
          <motion.div
            animate={{ scaleX: 1.2 }}
            transition={{ repeat: Infinity, duration: 2 }}
          >
            <Button style={{ margin: 0, padding: 0 }} onClick={searchClue}>
              <img src={props.search} />
            </Button>
          </motion.div>
        </div>
      </div>
    </Box>
  );
}
